<template >
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div :style="`height: ${detailHeight}px; overflow-y: auto`">
        <t-form
          ref="companyTableData"
          name="companyTableData"
          :model="companyTableData"
          label-position="flex-end"
          label-width="180px"
          domain="companyTableData"
        >
          <t-row :style="{ marginTop: marginTop + 'px', minWidth: '600px' }">
            <t-col :span="span" :offset="spanLeft">
              <!-- 会社名 -->
              <t-form-item
                :label="$t('resource.CompanyInfo.cmpName')"
                prop="cmpName"
              >
                <t-input
                  v-model="companyTableData.cmpName"
                  maxLength="40"
                  clearable
                  class="inputStyle"
                ></t-input> </t-form-item
            ></t-col>
          </t-row>

          <t-row style="margin-top: 6px; min-width: 600px">
            <t-col :span="span" :offset="spanLeft">
              <!-- アドレス -->
              <t-form-item
                :label="$t('resource.CompanyInfo.cmpAdd')"
                prop="cmpAdd"
              >
                <t-input
                  v-model="companyTableData.cmpAdd"
                  maxLength="100"
                  clearable
                  class="inputStyle"
                ></t-input> </t-form-item
            ></t-col>

            <t-col :span="span">
              <!-- TEL -->
              <t-form-item
                :label="$t('resource.CompanyInfo.cmpTel')"
                prop="cmpTel"
              >
                <t-input
                  v-model="companyTableData.cmpTel"
                  maxLength="15"
                  clearable
                  class="inputStyle"
                ></t-input></t-form-item
            ></t-col>
          </t-row>
          <t-row style="margin-top: 6px; min-width: 600px">
            <t-col :span="span" :offset="spanLeft">
              <!-- FAX -->
              <t-form-item
                :label="$t('resource.CompanyInfo.cmpFax')"
                prop="cmpFax"
              >
                <t-input
                  v-model="companyTableData.cmpFax"
                  maxLength="20"
                  clearable
                  class="inputStyle"
                ></t-input></t-form-item
            ></t-col>

            <t-col :span="span">
              <!-- 郵便番号 -->
              <t-form-item
                :label="$t('resource.CompanyInfo.cmpZipcode')"
                prop="cmpZipcode"
              >
                <t-input
                  v-model="companyTableData.cmpZipcode"
                  maxLength="15"
                  clearable
                  class="inputStyle"
                ></t-input> </t-form-item
            ></t-col>
          </t-row>

          <t-row style="margin-top: 6px; min-width: 600px">
            <t-col
              :span="span * 2"
              :offset="spanLeft"
              justify-content:
              flex-end
            >
              <!-- 仕入先の交货地址（日本）-->
              <t-form-item
                :label="$t('resource.CompanyInfo.cmpDeliveryAdd')"
                prop="cmpDeliveryAddr"
              >
                <t-input
                  v-model="companyTableData.cmpDeliveryAddr"
                  maxLength="100"
                  clearable
                ></t-input>
              </t-form-item>
            </t-col>
          </t-row>
          <!-- 取引銀行 -->
          <t-row style="margin-top: 6px; min-width: 600px">
            <t-col :span="span * 2" :offset="spanLeft">
              <t-form-item
                :label="$t('resource.CompanyInfo.cmpTradeBank')"
                prop="cmpTradeBank"
              >
                <t-table
                  ref="bankList"
                  :data="bankList"
                  :height="tableHeight"
                  class="table_common"
                  highlight-current-row
                  header-cell-class-name="bg-default"
                  border
                >
                  <t-table-column
                    v-for="(column, index) in columns"
                    :key="index"
                    :type="column.type"
                    :prop="column.prop"
                    :label="column.label"
                    :min-width="column.width"
                    :class-name="column.class"
                    :show-overflow-tooltip="column.overflowTooltip"
                  >
                    <template slot-scope="scope">
                      <t-input
                        v-if="true"
                        class="editInput"
                        :controls="false"
                        :maxLength="column.maxLength"
                        v-model="scope.row[column.prop]"
                      />
                    </template>
                  </t-table-column>
                </t-table>
              </t-form-item>
            </t-col>
          </t-row>

          <!-- <t-row style="margin-top: 6px">
            <t-col :span="span * 2" :offset="spanLeft" class="right">
              <t-button
                type="warning"
                round
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirm"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </t-row> -->
        </t-form>
      </div>
      <div :style="`height: ${bottomHeight}px`">
        <div style="text-align: right">
          <t-button
            type="warning"
            round
            class="dialogButton_confirm_120_40"
            ref="confirmBtn"
            @click="confirm"
          >
            <i class="el-icon-check"></i>
            {{ $t("resource.sys.sure") }}</t-button
          >
        </div>
      </div>
    </t-card>
  </div>
</template>

<script>
import { t } from "@/locales";
import { ChangeCmpMstInfo, GetCmpMstInfo } from "@/services/companynfo";
import {
  getDialogContentHeight,
  getDialogContentHeightComm,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message as MessageA, Modal } from "@tellus/component";
export default {
  data() {
    return {
      offset: 3,

      spanLeft: 2,

      spanRight: 3,

      marginTop: 60,

      span: 10,

      showFlag: false,

      tableHeight: DIALOG_LINE_HEIGHT * 5,

      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
      //明細情報のheight
      // detailHeight: getDialogContentHeight(window.innerHeight, 0, 0, 0),
      detailHeight: getDialogContentHeightComm(window.innerHeight, 0, 0, 0),
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
      companyTableData: {
        cmpName: "",
        cmpAdd: "",
        cmpTel: "",
        cmpFax: "",
        cmpZipcode: "",
        cmpTradeBankOne: "",
        cmpTradeBankOneNum: "",
        cmpTradeBankTwo: "",
        cmpTradeBankTwoNum: "",
        cmpDeliveryAddr: "",
      },

      bankList: [],

      columns: [
        // 取引銀行
        {
          prop: "bankName",
          label: t("resource.CompanyInfo.cmpTradeBank"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 100,
          overflowTooltip: false,
        },
        // 取引銀行番号
        {
          prop: "bankNum",
          label: t("resource.CompanyInfo.cmpTradeBankNum"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 100,
          overflowTooltip: false,
        },
      ],
    };
  },

  created() {
    this.handleResize();
  },

  mounted() {
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      this.searchClick();
    },

    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
      //明細情報のheight
      // this.detailHeight = getDialogContentHeight(window.innerHeight, 0, 0, 0);
      this.detailHeight = getDialogContentHeightComm(
        window.innerHeight,
        0,
        0,
        0
      );
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑

      if (window.innerHeight < 770) {
        this.marginTop = 10;
      } else {
        this.marginTop = 60;
      }

      if (window.innerWidth < 1600) {
        this.spanLeft = 0;
        this.span = 11;
      } else {
        this.spanLeft = 2;
        this.span = 10;
      }
    },
    // filterNumber(row) {
    //   // 行データ
    //   let element = this.bankList[row];

    //   element.bankNum = element.bankNum.replace(/\D/g, "");
    // },

    // 検索
    searchClick() {
      GetCmpMstInfo()
        .then((res) => {
          this.companyTableData = res;

          this.bankList = this.companyTableData.bankInfoDtos;

          let nullRowCnt = 5;
          let listSize = this.bankList.length;

          for (let i = 0; i < listSize; i++) {
            this.bankList[i].index = i;
          }

          for (let i = 0; i < nullRowCnt; i++) {
            this.bankList.push({
              // 番号
              index: listSize + i,
              //取引銀行
              bankName: "",
              //取引銀行
              bankNum: "",
            });
          }
        })
        .catch((err) => {
          if (err.data != null) {
            MessageA.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            MessageA.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    inputCheck() {
      const errors = this.bankList.filter((b) => b.bankName && !b.bankNum);

      if (errors.length > 0) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.BANK_NUM_MUST_INPUT"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });

        return false;
      }

      return true;
    },

    // 編集
    confirm() {
      this.$refs.companyTableData.validate((valid) => {
        if (valid) {
          this.companyTableData.updateUser = localStorage.getItem("useId");

          if (!this.inputCheck()) {
            return;
          }

          ChangeCmpMstInfo(this.companyTableData)
            .then((res) => {
              MessageA.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            })
            .catch((err) => {
              if (err.data != null) {
                MessageA.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                MessageA.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
              }
            })
            .finally(() => {
              this.init();
            });

          // フォーカス削除
          this.$refs.confirmBtn.$el.blur();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
// ::v-deep .el-input__inner {
//   width: 280px;
// }
</style>
